import { Injectable, EventEmitter } from '@angular/core'
import { QuestionAnswer } from '../../../shared/components/page/page.model';
import { BehaviorSubject, Subject } from 'rxjs';
import { MatDrawer } from '@angular/material/sidenav';


@Injectable({
  providedIn:'root'
})
export class PageService {
  private messageSource = new BehaviorSubject([]);
  currentMessage = this.messageSource.asObservable();
  private messageSourceWorkflow = new BehaviorSubject([]);
  currentMessageWorkflow = this.messageSourceWorkflow.asObservable();
  private _subjectVisible = new Subject<any>();

  changeMessage(queslist: QuestionAnswer[]) {
    this.messageSource.next(queslist)
  }

  changeWorkflow(workflow){
    this.messageSourceWorkflow.next(workflow)
  }
  newEventVisible(event) {
    this._subjectVisible.next(event);
  }
  get eventsVisible$() {
    return this._subjectVisible.asObservable();
  }

  
}
